export const GOOGLE_PLAY_STORE_QIRA_LINK =
  'https://play.google.com/store/apps/details?id=com.qirapagos'
export const APP_STORE_QIRA_LINK =
  'https://apps.apple.com/ar/app/qira-pagos/id1560066652'
export const moneySymbol = '$'

